// Pakistan's tax year runs July to June. A month belongs to the tax year that began the
// July on or before it, so June 2026 is in 2025-2026 and July 2026 in 2026-2027. The
// server's tax slabs are keyed by that start year. Strings are taken as the server takes them.
export const fiscalStartYear = (month, year) => (Number(month) >= 7 ? Number(year) : Number(year) - 1);

export const fiscalYearLabel = (startYear) => `${startYear}-${Number(startYear) + 1}`;
